React = require 'react'
_ = require 'underscore'
Auth = require 'db/auth'
Browser = require '@trello/browser'
Util = require 'lib/util'
ModelCache = require 'db/model-cache'
Promise = require 'bluebird'
ninvoke = require 'lib/util/ninvoke'
trackUe = require 'debug/trackUe'
t = require('views/internal/recup-with-helpers')('home')
HomeBoardDndComponent = require 'views/home/home-board-dnd-component'
{ BoardTile } = require './presentational/tile'
{ trackUnsplashViewBySavedUrl } = require 'network/unsplash'

module.exports = class HomeBoardTile extends React.Component
  displayName: 'HomeBoardTile'

  constructor: ->
    @onStarClick = @onStarClick.bind(@)
    @trackClick = @trackClick.bind(@)
    @onMouseDown = @onMouseDown.bind(@)
    @onMouseUp = @onMouseUp.bind(@)
    @isSafariLeftClick = @isSafariLeftClick.bind(@)
    @onDragHover = @onDragHover.bind(@)
    @onDragEnd = @onDragEnd.bind(@)

  componentDidMount: ->
    { boardId, modelCache } = @props
    if boardId
      board = modelCache.get('Board', boardId)
      backgroundImage = board?.getPref('backgroundImage')
      if backgroundImage
        trackUnsplashViewBySavedUrl(backgroundImage)

  componentDidUpdate: (prevProps) ->
    { boardId, modelCache } = @props
    if boardId != prevProps.boardId
      board = modelCache.get('Board', boardId)
      backgroundImage = board?.getPref('backgroundImage')
      if backgroundImage
        trackUnsplashViewBySavedUrl(backgroundImage)

  onStarClick: (e) ->
    Util.preventDefault(e)

    { boardId, boardsType, orgId } = @props

    boardStarList = Auth.me().boardStarList
    verb = ''

    if !boardStarList.getBoardStar(boardId)?
      boardStarList.starBoard(boardId)
      verb = 'stars'
    else
      boardStarList.unstarBoard(boardId)
      verb = 'unstars'

    if orgId
      trackUe('home', verb, 'board', '', '', 'by clicking star in ' + boardsType + ' boards list when filtered by team', { boardId, teamId: orgId })
    else
      trackUe('home', verb, 'board', '', '', 'by clicking star in ' + boardsType + ' boards list', { boardId })

  trackClick: ->
    { boardId, boardsType, orgId } = @props

    if orgId
      trackUe('home', 'opens', 'board', '', '', 'by clicking board name in ' + boardsType + ' boards list when filtered by team', { boardId, teamId: orgId })
    else
      trackUe('home', 'opens', 'board', '', '', 'by clicking board name in ' + boardsType + ' boards list', { boardId })

  isSafariLeftClick: (e) ->
    browser = Browser.isSafari() && e.button == 0

  # onMouseDown and onMouseUp are here to prevent
  # Safari's default rendering <a> tags while they're
  # being dragged, which changes them to a gray box
  # containing the href attribute. The author of
  # React-DND has said this cannot be fixed, as it is
  # how Safari implements HTML5. The logic of our
  # workaround, then, is this:
  # If the <a> tag doesn't have an href attr, the image
  # will not change while being dragged. However, we do
  # need each board tile to have an href attr on right-click.
  # So, in non-Safari browsers, we do nothing onMouseDown, but
  # in Safari, if we detect a left click (which may lead into a
  # drag), we remove the href onMouseDown and reset it
  # onMouseUp, which occurs before the click. Dragging, plus
  # left/right click navigation, works everywhere -- and in Safari.
  onMouseDown: (e) ->
    if @isSafariLeftClick(e)
      boardTileLink = e.currentTarget
      boardTileLink.removeAttribute('href')

  onMouseUp: (e) ->
    { boardId, modelCache } = @props
    board = modelCache.get('Board', boardId)
    boardTileLink = e.currentTarget
    boardTileLink.setAttribute('href', board?.getUrl())

  onDragHover: (idBoardHoverer) =>
    boardStarList = Auth.me().boardStarList
    boardStar = boardStarList.getBoardStar(idBoardHoverer)
    index = boardStarList.getBoardIndex(@props.boardId)
    pos = boardStarList.getNewPos(boardStar, index)
    boardStar.set({ pos })

  onDragEnd: ->
    { boardId, orgId } = @props
    boardStarList = Auth.me().boardStarList
    boardStar = boardStarList.getBoardStar(boardId)

    if orgId
      trackUe('home', 'reorders', 'board', '', '', 'by dragging a board in starred boards list in right sidebar when filtered by team', { boardId, teamId: orgId })
    else
      trackUe('home', 'reorders', 'board', '', '', 'by dragging a board in starred boards list in right sidebar', { boardId })

    Promise.using ModelCache.getLock(), ->
      ninvoke boardStar, 'update', (pos: boardStar.get('pos'))
      .catch ->
    .done()
    return

  render: t.renderable ->
    { boardId, isDraggable, modelCache } = @props

    board = modelCache.get('Board', boardId)
    isLoggedIn = Auth.isLoggedIn()
    boardName = board?.get('name')
    orgName = board?.getOrganization()?.get('displayName')
    url = board?.getUrl()
    isStarred = board?.isStarred()

    backgroundTile = !!board.getPref('backgroundTile')
    backgroundImage = board.getPref('backgroundImage')
    backgroundImageThumbnail = if backgroundTile then backgroundImage else Util.smallestPreviewBiggerThan(board.getPref('backgroundImageScaled'), 400, 200)?.url ? backgroundImage
    backgroundColor = board.getPref('backgroundColor')

    if isDraggable
      t.tag HomeBoardDndComponent, {
        id: boardId
        backgroundColor
        boardName
        isDraggable
        isLoggedIn
        isStarred
        @onDragEnd
        @onDragHover
        @onMouseDown
        @onMouseUp
        @onStarClick
        orgName
        starIconTitle: t.l('star-board')
        thumbnailUrl: backgroundImageThumbnail
        @trackClick
        url
      }

    else
      t.tag BoardTile, {
        backgroundColor
        boardName
        isLoggedIn
        isStarred
        @onMouseDown
        @onMouseUp
        @onStarClick
        orgName
        starIconTitle: t.l('star-board')
        thumbnailUrl: backgroundImageThumbnail
        @trackClick
        url
      }



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-board-tile.coffee